import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  medicalPatient,
  medicalWaste,
  officeAsset,
  retailExhibition,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingAsset/video/rtlsVideo.mp4';

export default {
  desc: 'Công nghệ RFID đã được sử dụng hiệu quả trong nhiều năm trong lĩnh vực logistics và theo dõi tài sản của doanh nghiệp. Tuy nhiên, gần đây, thay vì RFID, công nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) đang thu hút sự chú ý trong lĩnh vực quản lý logistics và tài sản.',
  keywords: 'RFID, RTLS, UWB, truyền thông không dây, rfid, rtls, uwb, truyen thong khong day.',
  ogSite: 'RTLS - giải pháp thay thế RFID',
  title: 'RTLS - giải pháp thay thế RFID',
  ogUrl: 'https://orbro.io/vi/blog/rfid-rtls',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDydFqsSpxfUGJRfgotjd5r5s27p9Jf2p08DcmZQY7K9VFxeg9rqDdYY9Gty2zcbPdkTtDG8IT8VHVI8Cu9Xay4Y9sNkWKyhNf5MZZfEJmSwx5RxDXIBhNLiVFBCl6asQi7XkVXIwVpqgVKugt94uXMpRmAUIUCYNCbhGMRV0zD7wJHpv6g4sEO3b3FkYBmPo0wrorAZ2UZIwYz4wRbFewYqqUgH0P6BidU5KE0kQsn2HGiIRRQlmCsPEY3rI0XKSGLatvI5vRo7-7c8DOoNlcOIpsMLXxaBYF3suQGFhdxrqEhA8t5mY3vsnWX2JOTgDdhEae70uPkPmf6IqEUhYr4i-kDTR-rCIjoikpAUHb2w5BUtdC3vMMJ3K8zZ2WbXTUDfkeCyjCN8C95-hMsUQX_dK52Yb2k6kTPrFuJWsiL7OSFsXX7TyjBajZX3yx1DfjD2OitZ7pZZSD6HV37MrXk0sykUNnUTbjSdW3NNVWoIBs0F4ur3TY23NSm8UKCWdXDvmlGsQrur-inPNF8C0iYeb2fEkwmH-WPv92-_V2JM5Q7t--49WhtDqsZHE5jlndPD7lFWwQa2qfEKhOExytxc3Vxt4LvM9BWSz3eR4p0jQt8OX3pXvRFcoc6wZEGANIoVWjvXj8HyvYZaYE56ckP2tHBQoruYpNVs4AfP8_ECNMPz4tfxLmvLQF9XYGOu_QZAFxMshOsDsJmAFOiRvKRKtNYQzCaJFgZCWibWTWvkbo52R_irSOgQZqIahJbvebkjVJmY8s9HJ0ouwoM7hApeuHgaFpMQ8gN1ov_4CqlBoa_pGCFaZvMOiJzqLIImEuRDrGWGOb9XuHS6dI22h-k3C5498w8ybVmF45VfA76In3QlmWtMx7ua2zT_bsj1AWfMJWaglRKkImhInZNRwMZFSSifk4ept8JyDKQox_XnxyJkVdojTLFKruj3z_uJ6M8nVcbIspvyz1QggC63Fp3acz35N2EXmQ0J8JZeWUnyLrhuwfJ-Wc6Ovja6LEF9gbjgAoesYWEghHYi3ByOzsEcFhHsQM9cQ1UgZUrRg_nf3Ic1V49R3ewe6J5HmaIqXADdHXQ4fWuZjZ4RpRe9ffQThkcH9PwHGFH5eRvgMLO2Ey8q_PdaHnN-1B2tUJ7IWkt2GMllFbOnfC2F7Z7yhNLOWss-MAXrtBW702-RreLR8GFAlMB7UnW3xrKC7GJCnJqJQfL913t9SZJyXm_52svc-p4d0UlQvuYUN7N0AA34STZtooGf9cSNITDeb62jWztMNJFGTw5YVTHqdsVttLICWXOO1_Q8_ygXfLtKu_YvfGDfhZqIqyMgk8OcDk1rYzMYok0P0j6grBuhSs8IyoPctYZddBCbfjze8PiLcDu22_gIz6biHHDr1-R4WtPNoyWavEKXnWNLMRAnSxy67bG83C5wbqYWv4pDA8mTGd1QfYqxLh4e2a4TXm6vxN0SOt_CJZSEa6cO64dcsuX74_Y12xT2AtRXErifMIoUyB0JFZCUbLPWq1jd20L_J22kFD6e-uaGmBSUQH_gZsMmYuS9Sf82buto=w2087-h1196',
  ogType: 'website',
  date: '2023-11-28',
  tag1: '#Rfid',
  tag2: '#Rtls',
  tag3: '#Uwb',
  tag4: '#Truyenthongkhongday',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Công nghệ RFID đã được sử dụng hiệu quả trong nhiều năm trong lĩnh vực logistics và theo dõi tài sản của doanh nghiệp. Tuy nhiên, gần đây, thay vì RFID, công nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) đang thu hút sự chú ý trong lĩnh vực quản lý logistics và tài sản. Bài viết này sẽ xem xét cách RTLS, thay thế cho RFID, mang lại sự đổi mới vượt xa các phương pháp hiện có.',
      dot: '',
    },
    {
      head: 'Khái niệm và nguyên lý hoạt động của RTLS',
      subHead: '',
      desc: 'RFID là công nghệ nhận dạng vật thể thông qua các nhãn hoặc thẻ vật lý, chỉ có thể thu thập thông tin trong một phạm vi nhất định. Ngược lại, RTLS là một hệ thống kết hợp công nghệ truyền thông không dây và theo dõi vị trí để có thể xác định vị trí của vật thể theo thời gian thực. RTLS sử dụng GPS, cảm biến, beacon, v.v., để cung cấp thông tin vị trí chính xác, do đó thể hiện hiệu suất vượt trội trong quản lý logistics và tài sản.',
      dot: '',
    },
    {
      head: 'Ưu điểm của RTLS',
      subHead: 'Theo dõi vị trí thời gian thực',
      desc: 'RTLS có thể xác định chính xác vị trí của vật thể theo thời gian thực, cho phép theo dõi tức thời trong quản lý logistics. Điều này giúp tối ưu hóa lộ trình di chuyển của sản phẩm và thực hiện các hoạt động logistics một cách hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cung cấp dữ liệu chính xác',
      desc: 'RFID chỉ có thể thu thập thông tin trong một phạm vi nhất định nên độ chính xác bị hạn chế. Tuy nhiên, RTLS kết hợp với cảm biến cung cấp thông tin vị trí với độ chính xác cao, do đó có thể thu được dữ liệu chính xác trong quản lý logistics và tài sản.',
      dot: '',
    },
    {
      head: 'Nên chọn công nghệ nào?',
      subHead: 'Đa dạng lĩnh vực ứng dụng',
      desc: 'RTLS không chỉ được ứng dụng trong logistics mà còn trong nhiều lĩnh vực công nghiệp khác như y tế, sản xuất, vận tải. Điều này có nghĩa là doanh nghiệp có thể áp dụng một công nghệ cho nhiều lĩnh vực khác nhau để tối đa hóa hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Các trường hợp thành công và hiệu quả kinh doanh',
      desc: 'Trên toàn cầu, các doanh nghiệp đã triển khai RTLS đang đạt được năng suất và hiệu quả cao. Ví dụ, trong lĩnh vực y tế, bằng cách sử dụng RTLS để theo dõi thiết bị y tế và vị trí bệnh nhân theo thời gian thực, việc phản ứng nhanh chóng trong các tình huống khẩn cấp trở nên khả thi; còn trong lĩnh vực logistics, chi phí đang được cắt giảm thông qua việc tối ưu hóa lộ trình di chuyển của sản phẩm.',
      dot: '',
    },
    {
      head: 'Triển vọng tương lai',
      subHead: '',
      desc: 'Mặc dù RFID đã được sử dụng hiệu quả ngay cả trong những môi trường trước đây gặp nhiều khó khăn, sự xuất hiện của RTLS đã cho phép quản lý logistics và tài sản một cách tinh vi và hiệu quả hơn. Trong tương lai, dự kiến sẽ có các hệ thống RTLS tiên tiến hơn nữa thông qua sự kết hợp với trí tuệ nhân tạo, việc áp dụng công nghệ blockchain, v.v., và các doanh nghiệp sẽ cần phải tích cực áp dụng những công nghệ này để đảm bảo năng lực cạnh tranh.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Lý do RTLS đang thu hút sự chú ý thay cho RFID nằm ở chỗ nó cho phép quản lý logistics và tài sản hiệu quả hơn thông qua việc theo dõi vị trí thời gian thực và cung cấp dữ liệu chính xác. Các doanh nghiệp cần phải chuẩn bị cho sự cạnh tranh trên thị trường tương lai bằng cách tích cực áp dụng các công nghệ đổi mới vượt trội so với các phương pháp hiện có. Việc chuyển đổi từ RFID sang RTLS sẽ là một bước tiến để các doanh nghiệp hiện đại chuẩn bị cho một tương lai tốt đẹp hơn thông qua công nghệ mới.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
